import React from 'react'
import { SubmitButton, UndoButton, Columns, Rows, ModalBlock, ModalToolbar } from 'labguard-cdk'

export default function FormModal(props) {
  return (
    <Rows gap="1rem">
      <ModalBlock {...props} />
      <Columns layout="auto" justify="end">
        <ModalToolbar>
          <UndoButton />
          <SubmitButton />
        </ModalToolbar>
      </Columns>
    </Rows>
  )
}
